import React from "react";
import { TessaMessageRendererProps } from "@webV2/pages/Tessa/types";
import { MarkdownView } from "@cmp-src/controls/MarkdownEditor/MarkdownView";
import { AiChatTextPart, TessaMessageTypes } from "@gettactic/api";
import { ChatBotToolCard } from "@webV2/pages/Tessa/ChatBotToolCard";
import { useAskTessa } from "@v2/components/ai/AskTessaProvider";
import { cn } from "@gettactic/helpers";

export const ChatBotTextTool: React.FC<
  TessaMessageRendererProps<AiChatTextPart>
> = ({ part, isResponse }) => {
  const askTessa = useAskTessa();
  if (part.type !== TessaMessageTypes.text) return null;
  const isCompact = askTessa?.fullPageToolDisclosure?.isOpen;
  const isPopup = !!askTessa?.isPopup;
  if (!isResponse) return <MarkdownView markdown={part.text} />;

  return (
    <ChatBotToolCard
      toolId={part.toolCallId}
      isThinking={!part.text}
      className={cn(
        "rounded-xl bg-white/80",
        !isCompact && !isPopup && "max-w-[60%]"
      )}
      isZoomEnabled={false}
    >
      <div className={"hyphens-auto break-words"}>
        <MarkdownView markdown={part.text} />
      </div>
    </ChatBotToolCard>
  );
};
